import React from 'react';
import NukaCarousel from 'nuka-carousel';

export class Carousel extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            slidesLoaded: [true],
        };
        this.loadSlide = this.loadSlide.bind(this);
        this.setDimensions = this.setDimensions.bind(this);
    }

    setDimensions() {
        if (this.carousel) {
            this.carousel.setDimensions();
        }
    }

    loadSlide(index) {
        let slidesLoaded = this.state.slidesLoaded.slice(0);
        const { afterSlide } = this.props;
        slidesLoaded[index] = true;
        //load next few slides to prevent flicker
        slidesLoaded[index + 1] = true;
        slidesLoaded[index + 2] = true;
        this.setState(
            {
                slidesLoaded,
            },
            () => {
                if (afterSlide) afterSlide(index);
            },
        );
    }

    render() {
        const { lazyLoad, children, afterSlide, enableKeyboardControls = true, ...carouselProps } = this.props;
        return (
            <NukaCarousel
                {...carouselProps}
                enableKeyboardControls={enableKeyboardControls}
                afterSlide={this.loadSlide}
                ref={carousel => (this.carousel = carousel)}
            >
                {React.Children.map(this.props.children, (child, i) => {
                    if (!lazyLoad || this.state.slidesLoaded[i]) return child;
                    else return <div></div>;
                })}
            </NukaCarousel>
        );
    }
}

export const setCarouselHeight = carousel => {
    if (carousel) {
        carousel.setDimensions();
    }
};
